import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared';
import { BaseUser } from '../../shared/auth/dto/base-user';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  replaceUrl: boolean = false;
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('네비게이션 extras state:', this.router.getCurrentNavigation()?.extras);
    this.replaceUrl = this.router.getCurrentNavigation()?.extras.replaceUrl;
    // 상태를 전달하거나 검사
    const currentUser = this.authService.getUser();

    // get refresh token
    if (!currentUser) {
      return new Promise((resolve) => {
        this.authService.getRefreshToken().then((user) => {
          resolve(this.isValidAuth(user, next, state));
        });
      });
    }

    return this.isValidAuth(currentUser, next, state);
  }

  isValidAuth(currentUser: BaseUser, next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // const redirectTo = next.data.redirectTo || '/home';
    if (!next.data.roles) {
      return true;
    }

    if (currentUser) {
      // console.log('guard role diff user : [', currentUser.userRoles,
      //   '] check role : [', next.data.roles, ']',
      //   this.intersection(next.data.roles, currentUser.userRoles));
      // check if route is restricted by role
      if (next.data.roles && this.intersection(next.data.roles, currentUser.userRoles).length === 0) {
        // role not authorised so redirect to home page
        this.router.navigate(['/signin'], {
          queryParams: { redirect: state.url },
        });
        return false;
      }

      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/signin'], {
      queryParams: { redirect: state.url },
    });
    return false;
  }

  intersection(input: any, ...args: any[]): any {
    if (!Array.isArray(input)) {
      return input;
    }

    // tslint:disable-next-line no-bitwise
    return args.reduce((n, c) => n.filter((e: any) => !!~c.indexOf(e)), input);
  }
}
